export default __webpack_public_path__ + "static/media/LOGO.bda03b86.webp";